import React from 'react';
import { Triangle } from 'react-loader-spinner';

function Preloader() {
  // Get initial theme from system preference
  const theme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

  return (
    <div className={`custom-preloader-bg ${theme}`}>
    <Triangle
  height="150"
  width="150"
  color="#4C5FD7"
  ariaLabel="triangle-loading"
  wrapperStyle={{}}
  wrapperClassName=""
  visible={true}
/>
        </div>
  );
}

export default Preloader;
